import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ForgetPasswordDTO, GetTenantInfoDTO } from '@app/core/types/user';
import { RestMessage } from '@app/core/types';
import { ToastService } from '@app/shared/services/toast/toast.service';
// import { file } from 'babel-types';

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
  standalone: false,
})
export class ForgetPasswordComponent implements OnInit {
  user: any = {};
  email: string;
  error: string;
  isError: boolean = false;
  submitted: boolean;
  forgetPassword: ForgetPasswordDTO;
  getTenantInfo: GetTenantInfoDTO;
  response: any;

  isSubmit: boolean = false;
  isClearViewEnv: boolean = true;
  isReflecxEnv: boolean = false;
  isMBCEnv: boolean = false;
  imagePath: any = undefined;
  tenant: any = undefined;
  clientId: any = null;
  constructor(
    public authService: AuthenticationService,
    private route: ActivatedRoute,
    private cdf: ChangeDetectorRef,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.isSubmit = false;
    this.isError = false;

    this.getTenantInfo = { Url: window.location.origin };
    this.authService.getTenantInfo(this.getTenantInfo).subscribe((response: any) => {
      if (response && response.IsWhitelabelled) {
        const path = response.LoginImageUrl;
        const tenant = response.ClientName;

        if (path) {
          this.imagePath = path;
          if (this.imagePath) {
            this.imagePath = this.imagePath + '?' + this.getVersionNumber();
          }
          this.cdf.detectChanges();
        }
        if (tenant) {
          this.tenant = tenant;
          this.authService.getClientByName(this.tenant).subscribe((response: any) => {
            this.clientId = response.Id;
          });
        }
      }
    });

    this.checkEnvironment();
  }

  getVersionNumber() {
    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const date = d.getDate();
    const hours = d.getHours();
    const mins = d.getMinutes();
    const sec = d.getSeconds();
    const randomNumber = Math.floor(Math.random() * 100000 + 1);

    const version = year + '' + month + '' + date + '' + hours + '' + mins + '' + sec + '' + randomNumber;
    return version;
  }

  checkEnvironment() {
    this.isReflecxEnv = false;
    this.isMBCEnv = false;
    this.isClearViewEnv = true;

    var baseUrl = window.location.origin;
    if (baseUrl.includes('reflecx')) {
      this.isReflecxEnv = true;
      this.isClearViewEnv = false;
    } else if (baseUrl.includes('mbcvoices')) {
      this.isMBCEnv = true;
      this.isClearViewEnv = false;
    } else {
      this.isClearViewEnv = true;
    }
  }
  onChange(val: string) {
    this.isError = false;
  }

  forgotPassword(email: any) {
    var emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

    if (email === undefined || email === '') {
      this.error = "Sorry, we don't recognize this User ID.";
      this.isSubmit = false;
      this.isError = true;
      return;
    }
    //  else if (email !== '' && !emailPattern.test(email)) {
    //   this.error = 'Invalid email. Please try again.';
    //   this.isSubmit = false;
    //   return;
    //}
    else {
      this.error = '';
      this.isSubmit = true;
      this.isError = false;
    }

    this.forgetPassword = { Username: email, ClientId: this.clientId };

    this.authService.forgotPassword(this.forgetPassword).subscribe((response: RestMessage) => {
      this.toastService.success('Please check your email for reset password link.');
      this.isSubmit = false;
      this.isError = false;
      this.error = '';
      this.email = '';
    });
  }
}
